import moment from "moment";

/**
 * filter table rows 
 * @param {*} data 
 * @param {*} filterArray 
 * @param {*} key 
 * @returns 
 */
export function filterTableRows(data = [], filterArray = [], key = null, apiCallData = []) {
	if (!data || (data && !data.length) || !filterArray.length) return data;
	let filteredData = data;

	filterArray.forEach(filter => {
		if (apiCallData.find(x=> x.key === filter.keyName) === undefined) {
			switch (filter.filterType) {
				case "string":
					filteredData = filteredData.filter(x =>
						(x[filter.keyName] + "" || "").toLowerCase().includes((filter.value || "").toLowerCase()) ||
						(x?.childData || []).find(y => (y[filter.keyName] + "" || "").toLowerCase().includes((filter.value || "").toLowerCase()))
					);
					break;
				case "multiSelectSearch":
				case "multiSelect":
					filteredData = filteredData.filter(function (x) {
						if (x[filter.keyName] && x[filter.keyName].includes(",")) {
							return x[filter.keyName].split(",").filter((k) =>
								filter.value?.indexOf(k) !== -1
							).length > 0 || filter.value?.length == 0 || (x?.childData || [])
							.filter(y =>y[filter.keyName].split(",").filter((k) =>
							filter.value?.indexOf(k) !== -1
						).length > 0 ).length > 0;
						}
						else {
							return (x[filter.keyName] &&(
								filter.value?.indexOf(x[filter.keyName] || "") !== -1) ||
								(x?.childData || []).find(y=> filter.value?.indexOf(y[filter.keyName] || "") !== -1) )|| filter.value?.length == 0
						}
					} 
					);

					break;
				case "dateRange":
					if (filter.value && filter.value.length > 0) {
						const [startDate, endDate] = filter.value.split("-");
						const sDate = new Date(startDate);
						const eDate = new Date(endDate);

						eDate.setDate(new Date(endDate).getDate() + 1);
						if (key == filter.keyName) {
							sDate.setDate(new Date(startDate).getDate() - 1);
							filteredData = filteredData.filter(x =>
								moment(x[filter.keyName]).isBetween(sDate, eDate) ||
								(x?.childData || []).find(y => moment(y[filter.keyName]).isBetween(sDate, eDate))
							);
						}
						else {
							filteredData = filteredData.filter(x =>
								moment(x[filter.keyName]).isBetween(startDate, eDate) ||
								(x?.childData || []).find(y => moment(y[filter.keyName]).isBetween(startDate, eDate))
							);
						}
					}
					break;
			}
		}
	});
	return filteredData;
}
